import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'matricula'
})
export class MatriculaPipe implements PipeTransform {
    transform(value: string): string {
        if (value) {
            if (value.length === 10) {
                return value.substring(0, 2).concat('.')
                    .concat(value.substring(2, 3))
                    .concat('.')
                    .concat(value.substring(3, 6))
                    .concat('.')
                    .concat(value.substring(6, 9))
                    .concat('-')
                    .concat(value.substring(8, 9));
            } if (value.length === 7) {
                return value.substring(0, 1)
                    .concat('.')
                    .concat(value.substring(1, 4))
                    .concat('.')
                    .concat(value.substring(4, 7))
            } else {
                return value.substring(0, 1).concat('.')
                    .concat(value.substring(1, 2))
                    .concat('.')
                    .concat(value.substring(2, 5))
                    .concat('.')
                    .concat(value.substring(5, 8))
                    .concat('-')
                    .concat(value.substring(7, 8));
            }
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/pipe/matricula.pipe.ts